import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { LevelSelectScene } from './scenes/LevelSelectScene';
import { GameScene } from './scenes/GameScene';
import { GameOverScene } from './scenes/GameOverScene';
import { GAME_WIDTH, getGameHeight, initGameHeight } from './config/constants';
import { initVersionCheck } from './utils/version-check';
import { showVersionUpdateModal } from './utils/version-update-modal';
import { unregisterLegacyServiceWorker } from './utils/unregister-sw';

// Tear down any leftover service worker from the old vite-plugin-pwa setup.
// Safe no-op on devices that never had one; leave in place indefinitely so
// long-absent returning users don't stay pinned to a stale precached bundle.
unregisterLegacyServiceWorker();

// Compute dynamic game height based on viewport before creating the game
initGameHeight();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: getGameHeight(),
  backgroundColor: '#1a1a2e',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
  },
  scene: [BootScene, MenuScene, LevelSelectScene, GameScene, GameOverScene],
};

const game = new Phaser.Game(config);

// ── Version check ─────────────────────────────────────────────────────────
// On boot: hard-reload if /version.txt differs from the baked __BUILD_ID__.
// On tab refocus with a new version deployed: pause all active scenes and
// show a modal prompting the user to reload.
initVersionCheck({
  onStale: (remoteVersion) => {
    // Pause every active, non-sleeping scene so the game freezes under
    // the modal. Using scene.pause (not sleep) preserves state and stops
    // the update loop; we never intend to resume — the modal's Reload
    // button triggers a full navigation.
    for (const scene of game.scene.getScenes(true)) {
      if (!scene.scene.isPaused()) {
        scene.scene.pause();
      }
    }
    showVersionUpdateModal(remoteVersion);
  },
});
